import { Card, CardBody, Col, Container, Row, Table, } from "reactstrap";
import { Image, Btn, H5, H4 } from "../../AbstractElements";
import { convertAmountToWordsGNF, URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { formatPhoneNumber, formatPrice, generateRandomNumber } from "../../utils/helper/helpers";

import { Link, useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";
import H2 from '../../CommonElements/Headings/H2Element';

// Types
type Recus = { [key: string]: any }

const ShowRecu = () => {

    const [recu, setRecu] = useState<Recus | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [refresh, setRefresh] = useState(false);
    const params = useParams();
    const Token = JSON.parse(localStorage.getItem("login")!);

    // Fetch data from API
    const fetchRecu = useCallback(async () => {
        try {
            const response = await axios.get(`${URL_API}/recu/show/${params.id}`, {
                headers: { Authorization: `Bearer ${Token}` }
            });
            if (response.status === 200) {
                setRecu(response.data.recu);

            }
        } catch (error: any) {
            const message = error.response?.data?.message || "Erreur inconnue";
            toast.error(message);
        }
    }, []);

    // Initial data fetch
    useEffect(() => {
        fetchRecu();
        setTimeout(() => {
            if ( recu && recu?.length > 0) {
                setIsLoading(false); // Les données sont chargées, on arrête le loader
              } else {
                setIsLoading(false);
              }
          }, 2000);
    }, [refresh, fetchRecu]);

    console.log(recu)

    const documentContent = (
        <>
            <h2>Mon Document PDF</h2>
            <p>Ceci est un exemple de document PDF généré avec React et html2pdf.js.</p>
            {/* Ajoutez plus de contenu ici selon vos besoins */}
        </>
    );

    const pdfRef = useRef<HTMLDivElement>(null);

    const generatePDF = () => {
        const element = pdfRef.current;
        const name_document = generateRandomNumber(100000, 999999);
        if (element) {
            html2pdf()
                .from(element)
                .save(`recu_de_paiement${name_document}.pdf`);
        }
    };


    return (
        <div className='page-body'>
            {isLoading ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
            ) : ( 
                <>
                    <Breadcrumbs mainTitle="Reçu Details" parent="Reçu" />
                    <Container fluid>
                        <Card>
                            <CardBody>
                                <div ref={pdfRef}>
                                    <div className="text-center mb-5 mt-5">
                                        <p dangerouslySetInnerHTML={{ __html: recu?.ets_description }}></p>

                                    </div>
                                    <h2 className="fw-bold text-center"> REÇU DE PAIEMENT</h2>
                                    <div className="mx-3 mt-5">
                                        <Table bordered responsive className="text-center">
                                            <thead>
                                                <tr className="f-18">
                                                    <th scope="col">No</th>
                                                    <th scope="col">CLIENT</th>
                                                    <th scope="col">MONTANT</th>
                                                    <th scope="col">DATE D'ÉMISSION</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="f-18">
                                                    <td className="text-capitalize">#{recu?.num}</td>
                                                    <td className="text-capitalize">{recu?.client}</td>
                                                    <td>{formatPrice(recu?.montant)}</td>
                                                    <td>{recu?.date_recu}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <span className="fw-bold f-18">MOTIF : </span>
                                        <span className="text-info my-2 f-18 fw-lighter text-capitalize" style={{ fontFamily: 'Courier' }}>{ recu?.motif }</span>
                                        <Row className="pt-3">
                                            <Col>
                                                <H4 className="text-center">Clients</H4>
                                            </Col>
                                            <Col>
                                                <H4 className="text-center">Gérant</H4>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <div className="text-center">
                                    <Btn color="light-info " onClick={generatePDF} className="btn btn-xs mx-1 p-1 px-3">
                                        <i className="fa fa-download"></i> Télécharger
                                    </Btn>
                                    <Link to="/factures" className="btn btn-xs mx-1 p-1 px-3 btn-light-danger">
                                        <i className="fa fa-sign-out"></i> Quitter
                                    </Link>
                                </div>
                            </CardBody>
                        </Card>
                    </Container>
                </>
            )}
            
        </div >

    )
}

export default ShowRecu;